module.exports = __webpack_public_path__ + "01_mole.b5166553.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer2/01_mole.png
// module id = Ad5c
// module chunks = 0